import { z } from 'zod';

import { DiagramChatChannelSchema } from './DiagramChatChannel.schema';

const Base = z.object({
    id: z.string(),
    project: z.string(),
    diagram: z.string(),
    channel: DiagramChatChannelSchema.shape.id,
    parent: z.string().nullish(),
    content: z
        .discriminatedUnion('blockType', [
            z.object({
                blockType: z.literal('message'),
                content: z.string(),
                files: z
                    .object({
                        file: z.string(),
                    })
                    .array()
                    .default([]),
            }),
            z.object({
                blockType: z.literal('credits.estimate'),
                credits: z.number(),
                description: z.string().nullish(),
                acceptedAt: z.string().nullable().optional(),
                acceptedBy: z.string().nullable().optional(),
                declinedAt: z.string().nullable().optional(),
                declinedBy: z.string().nullable().optional(),
            }),
            z.object({
                blockType: z.literal('credits.accept'),
                estimate: z.string(),
            }),
            z.object({
                blockType: z.literal('credits.decline'),
                estimate: z.string(),
            }),
            z.object({
                blockType: z.literal('credits.charge'),
                credits: z.number(),
                description: z.string(),
            }),
            z.object({
                blockType: z.literal('summary'),
                content: z.string().nullish(),
                generating: z.boolean().nullish(),
            }),
        ])
        .array(),
    reactions: z
        .object({
            reaction: z.string(),
            createdBy: z.string(),
            createdAt: z.string(),
        })
        .array(),
    as: z.string().nullish(),
    createdBy: z.string(),
    createdByCompany: z.string().nullish(),
    createdAt: z.string(),
    editedAt: z.string().nullish(),
    team: z.string(),
});

export const DiagramChatMessageSchema = Base.extend({
    thread: z.object({
        docs: z.array(Base),
        totalDocs: z.number(),
    }),
});
